import { DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { AppState } from '../../types/redux';
import { ContentfulState } from '../../redux/reducers/contentful/ContentfulState';
import ButtonClose from '../ButtonClose/ButtonClose';

const useStyles = makeStyles((theme) => ({
	dialogTitle: {
		padding: theme.spacing(2, 4, 2),
		backgroundColor: theme.palette.grey[100],
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(4, 6, 2),
		},
	},
	dialogContent: {
		padding: theme.spacing(0, 4, 2),
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(1, 6, 4),
		},
	},
	videoWrapper: {
		width: '100%',
		height: 0,
		paddingBottom: '56.25%',
		position: 'relative',
	},
	videoPlayer: {
		position: 'absolute',
		top: 0,
		left: 0,
		'& iframe': {
			marginTop: 0,
		},
	},
}));
export const VideoDialogContent: React.FC<{ handleClose(): void }> = ({
	handleClose,
}) => {
	const { t } = useTranslation();
	const contentful: ContentfulState = useSelector<AppState, ContentfulState>(
		(state) => state.contentful
	);
	// console.log("con " +contentful.quickMenuExplainVideoUrl)
	const classes = useStyles();
	const playerConfig = {
		youtube: {
			playerVars: {
				modestbranding: 1,
				rel: 0,
				showinfo: 0,
				iv_load_policy: 3,
				loop: 0,
			},
		},
	};

	return (
		<>
			<DialogTitle
				id="quick-menu-dialog"
				disableTypography={true}
				className={classes.dialogTitle}
			>
				<Typography variant="h2">{t('quickMenu.video.title')}</Typography>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<div className={classes.videoWrapper}>
					<ReactPlayer
						className={classes.videoPlayer}
						url={contentful.quickMenuExplainVideoUrl}
						width={'100%'}
						height={'100%'}
						config={playerConfig}
					/>
				</div>
			</DialogContent>
			<ButtonClose onClick={handleClose} />
		</>
	);
};
